import React from 'react';
import { Route } from 'react-router-dom';
import QaPage from '@pages/Qa/QaPage';

export const internalRoutes = [<Route key="qa" path="/qa" element={<QaPage />} />];

// A direct /qa entry is supported alongside the normal <basename>/qa URL.
// Every existing widget URL continues using its configured basename.
export const getRouterBasename = (pathname: string, configuredBasename: string): string =>
  pathname === '/qa' || pathname === '/qa/' ? '/' : configuredBasename;
